import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'company-hub.search-extension.custom-search-config-panel.title',
		defaultMessage: 'Custom search',
		description: 'A visible text label to be used as the title for the custom search config panel',
	},
	preamble: {
		id: 'company-hub.search-extension.custom-search-config-panel.preamble',
		defaultMessage: 'Add a filtered search bar',
		description:
			'A visible text label to be used as the preamble for the custom search config panel',
	},
});
